import "./Register.css";
import RegisterSection from "../components/RegisterSection";

const Register = () => {
  return (
    <div className="register">
      <RegisterSection />
    </div>
  );
};

export default Register;
